import React from 'react';

interface CardProps {
  children: React.ReactNode;
  className?: string;
}

const Card = ({ children, className = 'bg-white/60' }: CardProps) => (
  <div className={`${className} backdrop-blur-xl p-6 rounded-2xl shadow-lg shadow-gray-200/50 border border-white/80 hover:shadow-xl transition-shadow duration-300`}>
    {children}
  </div>
);

export default Card;
